export const getTurbines = () => {
  return [
    {
      id: 1,
      name: "Gamesa G114-2000kW IIA_IIIA",
      model_type: "Best perf.",
      nominal_power: 2000,
      height_of_the_rotor: 93,
      length_of_the_blade: 57,
      windspeed: [
        0, 1, 2, 2.9, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18,
        19, 20, 21, 22, 23, 24, 25, 25.1, 26, 27, 28, 29, 30,
      ],
      active_power: [
        0, 0, 0, 0, 32, 146, 342, 621, 1008, 1486, 1836, 1965, 1994, 1999, 2000,
        2000, 2000, 2000, 2000, 2000, 2000, 2000, 2000, 1906, 1681, 1455, 1230,
        0, 0, 0, 0, 0, 0,
      ],
    },
    {
      id: 2,
      name: "LTW 2000_kW IIIA+",
      model_type: "Mean perf.",
      nominal_power: 2030,
      height_of_the_rotor: 80,
      length_of_the_blade: 50.5,
      windspeed: [
        0, 1, 2, 2.9, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18,
        19, 20, 21, 22, 23, 24, 25, 25.1, 26, 27, 28, 29, 30,
      ],
      active_power: [
        0, 0, 0, 0, 41, 122, 268, 480, 772, 1162, 1634, 1983, 2000, 2000, 2000,
        2000, 2000, 2000, 2000, 2000, 2000, 2000, 2000, 2000, 2000, 2000, 2000,
        0, 0, 0, 0, 0, 0,
      ],
    },
    {
      id: 3,
      name: "Vestas V90-2000_kW IIA",
      model_type: "Long life",
      nominal_power: 2000,
      height_of_the_rotor: 80,
      length_of_the_blade: 45,
      windspeed: [
        0, 1, 2, 3, 3.9, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18,
        19, 20, 21, 22, 23, 24, 25, 25.1, 26, 27, 28, 29, 30,
      ],
      active_power: [
        0, 0, 0, 0, 0, 75, 190, 354, 582, 883, 1240, 1604, 1893, 2005, 2027,
        2029, 2030, 2030, 2030, 2030, 2030, 2030, 2030, 2030, 2030, 2030, 2030,
        0, 0, 0, 0, 0, 0,
      ],
    },
  ];
};
